import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { Dictionary } from 'lodash'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { UniqueLegalEntities } from 'modules/attendance/hooks/useLegalEntities'
import MapTimeBlockTaxonomyForm from 'modules/attendance/lib/forms/MapTimeBlockTaxonomyForm'
import { UniqueTimeBlockData } from 'modules/attendance/store/models/UniqueTimeBlockData'
import { ContractTaxonomy } from 'modules/contracts/hooks/useFetchContractsTaxonomies'
import { ReimbursableSupplementTaxonomyMapping } from 'modules/payroll_bundle/hooks/useFetchReimbursableSupplementMappings'

import TaxonomyDropdown from './Units/TaxonomyDropdown'

interface Props {
  onCancel: () => void
  totalCategories: number
  currentStep: number
  category: UniqueTimeBlockData
  legalEntities: UniqueLegalEntities
  taxonomiesByLegalEntity: Dictionary<ContractTaxonomy[]>
  mappings: ReimbursableSupplementTaxonomyMapping[]
}

const PayrollSupplement = ({
  onCancel,
  totalCategories,
  currentStep,
  category,
  legalEntities,
  taxonomiesByLegalEntity,
}: Props) => {
  const legalEntityForms = legalEntities.map((legalEntity) =>
    MapTimeBlockTaxonomyForm(legalEntity.id)
  )

  const legalEntityTaxonomies = (legalEntityId: string) =>
    taxonomiesByLegalEntity[legalEntityId] || []

  const options = (legalEntityId: string) =>
    legalEntityTaxonomies(legalEntityId).map((taxonomy) => ({
      label: taxonomy.name,
      value: taxonomy.id,
    }))

  return (
    <Modal
      illustration="money-bag"
      title={i18n.t('clock_in.sidepanel.compensation.modal.taxonomy.title', {
        category_name: category.name,
      })}
      description=""
      onClose={onCancel}
      onSubmit={() => {
        legalEntityForms.forEach((form) => {
          form.handleSubmit()
        })
      }}
      footer={
        <>
          <Button type="secondary" onClick={onCancel}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t('common.continue')}</Button>
        </>
      }
      progress={{ amount: currentStep, total: totalCategories }}
    >
      <Box background="grey200" padding="s16" gap="s16">
        {legalEntities.map((legalEntity, index) => (
          <Box key={legalEntity.id}>
            <Text color="grey1000" size="200" weight="medium">
              {legalEntity.legalName}
            </Text>
            <TaxonomyDropdown
              form={legalEntityForms[index]!}
              legalEntityId={legalEntity.id}
              timeRangeCategoryId={category.timeSettingsCustomTimeRangeCategoryId!.toString()}
              options={options(legalEntity.id)}
            />
          </Box>
        ))}
      </Box>
    </Modal>
  )
}

export default PayrollSupplement
